<template>
  <div>
    <hrms-staappr   :staappr='detail.staappr'
                    :nowLang="nowLang"
                    :currentDtereq="setDateOutput(currentDtereq)"
                    :currentNumseq="currentNumseq.toString()"
                    :currentCodempid="paramSearchDetail.codempid_query" />

    <div class="box-func">
      <div class="box-topic border-color-skin">
        <i class="fa fa-envelope margin-r-5 color-skin"></i>
        <label class="color-skin">{{ descCodapp }}</label>
      </div>

      <div class="box-body">
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-lg-1"></div>
              <div class="col-md-4 col-lg-3">
                <div class="form-group">
                    <label>{{ labels['HRMS62EC2']['10'] }}<span class="red">*</span></label>
                    <hrms-lov v-model="paramSearchDetail.codempid_query"
                              lovType="codempid"
                              :nowLang="nowLang"
                              name="codempid"
                              :disabled="eventBtn === 'edit'"
                              :descDisp="true"
                              :desc="descCodempidQuery"
                              v-validate="'required'"
                              :has-error="errors.has('codempid')"
                              @keyup.enter.native="validateCodempidQuery()"  />
                  <div class="text-error" v-show="errors.has('codempid')">{{errors.first('codempid')}}</div>
                </div>

                <div class="form-group">
                  <label>{{ labels['HRMS62EC2']['30'] }}<span class="red">*</span></label>
                  <hrms-dropdown  v-model="detail.codleave"
                                  :options="arrCodleave[nowLang]"
                                  :disabled="!validateStaappr"
                                  v-validate="'required'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codleave"
                                  :has-error="errors.has('codleave')" />
                  <div class="text-error" v-show="errors.has('codleave')">{{errors.first('codleave')}}</div>
                </div>
                <div>
                  <label>{{ labels['HRMS62EC2']['250'] }}<span class="red">*</span></label>
                  <div class="row">
                    <div class="form-group">
                      <div class="radio col-ms-6 col-sm-6 col-md-12">
                        <label>
                          <input type="radio" value="A" v-model="detail.flgleave" :disabled="enableFlagLeave.r1 == 'F' || !validateStaappr">
                          {{ labels['HRMS62EC2']['200'] }}
                        </label>
                      </div>
                      <div class="radio col-ms-6 col-sm-6 col-md-12">
                        <label>
                          <input type="radio" value="M" v-model="detail.flgleave" :disabled="enableFlagLeave.r2 == 'F' || !validateStaappr">
                          {{ labels['HRMS62EC2']['210'] }}
                        </label>
                      </div>
                      <div class="radio col-ms-6 col-sm-6 col-md-12">
                        <label>
                          <input type="radio" value="E" v-model="detail.flgleave" :disabled="enableFlagLeave.r3 == 'F' || !validateStaappr">
                          {{ labels['HRMS62EC2']['220'] }}
                        </label>
                      </div>
                      <div class="radio col-ms-6 col-sm-6 col-md-12">
                        <label>
                          <input type="radio" value="H" v-model="detail.flgleave" :disabled="enableFlagLeave.r4 == 'F' || !validateStaappr">
                          {{ labels['HRMS62EC2']['230'] }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group clearfix">
                  <label>{{ labels['HRMS62EC2']['180'] }}<span class="red">*</span></label>
                  <hrms-datepicker  v-model="detail.dteleave"
                                    :disabled="!validateStaappr"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    data-vv-name="dteleave"
                                    name="dteleave"
                                    :has-error="errors.has('dteleave')" />
                  <div class="text-error" v-show="errors.has('dteleave')">{{errors.first('dteleave')}}</div>
                </div>
                <div class="form-group">
                    <label>{{ labels['HRMS62EC2']['130'] }}</label>
                    <div class="form-control readonly-field-color">{{ inputName }}</div>
                </div>
              </div>

              <div class="col-md-8 col-lg-6">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{ labels['HRMS62EC2']['28'] }}</label>
                    <div class="input-group">
                      <input  v-model="entitlement.day3"
                              class="form-control text-center"
                              disabled />
                      <span class="input-group-addon disabled-icon">
                        {{ labels['HRMS62EC2']['270'] }}
                      </span>

                      <input  v-model="entitlement.hur3"
                              class="form-control text-center"
                              disabled />
                      <span class="input-group-addon disabled-icon">
                          {{ labels['HRMS62EC2']['280'] }}
                      </span>

                      <input  v-model="entitlement.min3"
                              class="form-control text-center"
                              disabled />
                      <span class="input-group-addon disabled-icon">
                          {{ labels['HRMS62EC2']['290'] }}
                      </span>
                      <div id="entitlement-loader" class="loader" style="display: none;"></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group clearfix">
                    <label>{{ labels['HRMS62EC2']['50'] }}<span class="red">*</span></label>
                    <hrms-datepicker  v-model="detail.dtestrt"
                                      v-validate="'required|date_format:DD/MM/YYYY|before:dteend'"
                                      data-vv-value-path="inputDate"
                                      data-vv-name="dtestrt"
                                      name="dtestrt"
                                      :disabled="disabledDtestrt"
                                      :has-error="errors.has('dtestrt')" />
                    <div class="text-error" v-show="errors.has('dtestrt')">{{errors.first('dtestrt')}}</div>
                  </div>
                  <div class="form-group clearfix">
                    <label>{{ labels['HRMS62EC2']['60'] }}<span class="red">*</span></label>
                    <hrms-datepicker  v-model="detail.dteend"
                                      v-validate="'required|date_format:DD/MM/YYYY|after:dtestrt'"
                                      data-vv-value-path="inputDate"
                                      data-vv-name="dteend"
                                      name="dteend"
                                      :disabled="disabledDteend"
                                      :has-error="errors.has('dteend')" />
                    <div class="text-error" v-show="errors.has('dteend')">{{errors.first('dteend')}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group clearfix">
                      <label>{{ labels['HRMS62EC2']['70'] }}</label>
                      <hrms-timepicker  v-model="detail.timstrt"
                                        v-validate="'requiredWhenExist:timend|date_format:HH:mm'"
                                        data-vv-value-path="inputTime"
                                        data-vv-name="timstrt"
                                        name="timstrt"
                                        :disabled="disabledTimstrt"
                                        :has-error="errors.has('timstrt')" />
                      <div class="text-error" v-show="errors.has('timstrt')">{{errors.first('timstrt')}}</div>
                  </div>
                  <div class="form-group clearfix">
                      <label>{{ labels['HRMS62EC2']['80'] }}</label>
                      <hrms-timepicker  v-model="detail.timend"
                                        v-validate="'requiredWhenExist:timstrt|date_format:HH:mm'"
                                        data-vv-value-path="inputTime"
                                        data-vv-name="timend"
                                        name="timend"
                                        :disabled="disabledTimend"
                                        :has-error="errors.has('timend')" />
                      <div class="text-error" v-show="errors.has('timend')">{{errors.first('timend')}}</div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group clearfix">
                      <label>{{ labels['HRMS62EC2']['40'] }}<span class="red">*</span></label>
                      <textarea v-validate="'required|max:200'" 
                                v-model="detail.deslereq" 
                                name="deslereq" 
                                maxlength="200"
                                :class="{ 'form-control' : true, 'input-error' : errors.has('deslereq') }" 
                                :disabled="!validateStaappr"></textarea>
                      <div class="text-error" v-show="errors.has('deslereq')">{{errors.first('deslereq')}}</div>
                      <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div> 
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                      <label>{{ labels['HRMS62EC2']['122'] }}</label>
                      <hrms-dropzone  :fileNameQuery="detail.filenam1"
                                      :prefixFileName="paramSearchDetail.codempid_query"
                                      :flgToggle="detailDisp"
                                      ref="hrmsDropzone"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <div class="col-xs-8 col-md-6 col-sm-6  clear-padding">
          <button type="button" class="btn bg-dark-gray" @click="triggerToggle()" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
        </div>
        <div class="col-xs-4 col-md-6 col-sm-6 clear-padding" align="right" >
          <button type="button"  class="btn bg-color-skin" @click="leaveCondition()" data-toggle="modal" href="#hrms62e-popup">{{ labels['HRMS62EC2']['100'] }}</button>
        </div>
      </div>

      <popup  :labels="labels"
              :data="popup" />

    </div>
  </div>
</template>

<script>
import popup from 'components/hrms62e/popup'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import moment from 'moment'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms62e-detail',
  data () {
    return {
      disabledDtestrt: false,
      disabledTimstrt: false,
      disabledDteend: false,
      disabledTimend: false,
      paramSearchDetail: {
        dtework: this.searchDetail.dtework,
        seqno: this.searchDetail.seqno,
        codempid_query: this.searchDetail.codempid_query
      },
      flgDeleteFile: true,
      tempFileName: '',
      tempFileName_: ''
    }
  },
  props: [ 'labels',
    'labelsButton',
    'detail',
    'toggle',
    'arrCodleave',
    'currentDtereq',
    'currentNumseq',
    'currentCodempid',
    'descCodempid',
    'nowLang',
    'postHrms62eSave',
    'indexSelected',
    'entitlement',
    'enableFlagLeave',
    'receivedHrms62eEntitlement',
    'worktime',
    'receivedHrms62eWorktime',
    'descCodapp',
    'eventBtn',
    'receivedHrms62eCreate',
    'searchDetail',
    'descCodempidQuery',
    'searchIndex',
    'popup',
    'receivedHrms62ePopup',
    'receivedHrms62eIndex',
    'receivedHrms62eCodleave',
    'detailDisp'
  ],
  created () {
    if (typeof this.arrCodleave[this.nowLang][this.detail.codleave] === 'undefined') {
      this.detail.codleave = ''
    }
  },
  mount () {
    this.erros.clear()
  },
  watch: {
    'searchDetail.dtework' (newVal) {
      this.paramSearchDetail.dtework = newVal
    },
    'searchDetail.seqno' (newVal) {
      this.paramSearchDetail.seqno = newVal
    },
    'searchDetail.codempid_query' (newVal) {
      this.paramSearchDetail.codempid_query = newVal
    },
    'paramSearchDetail.codempid_query' () {
      this.searchDetail.codempid_query = this.paramSearchDetail.codempid_query
      this.validateCodempidQuery()
      let searchParams = {
        p_dtework: this.detail.dteleave,
        p_codempid_query: this.paramSearchDetail.codempid_query
      }
      this.receivedHrms62eWorktime(searchParams)
      this.receivedHrms62eCodleave(searchParams)
    },
    enableFlagLeave () {
      this.detailFlgleave()
    },
    worktime () {
      this.triggerDetailFlgleaveChanged(this.detail.flgleave)
    },
    'detail.codleave' () {
      this.getEntitlement()
      this.$nextTick(() => {
        this.errors.clear()
      })
    },
    'detail.dtestrt' () {
      this.$validator.validate('dteend', this.detail.dteend).catch(e => {})
    },
    'detail.dteend' () {
      this.$validator.validate('dtestrt', this.detail.dtestrt).catch(e => {})
    },
    'detail.timstrt' () {
      this.$validator.validate('timend', this.detail.timend).catch(e => {})
    },
    'detail.timend' () {
      this.$validator.validate('timstrt', this.detail.timstrt).catch(e => {})
    },
    'detail.flgleave' () {
      this.triggerDetailFlgleaveChanged(this.detail.flgleave)
    },
    'detail.dteleave' (newVal) {
      this.detail.dtestrt = newVal
      this.detail.dteend = newVal
      let searchParams = {
        p_dtework: this.detail.dteleave,
        p_codempid_query: this.paramSearchDetail.codempid_query
      }
      this.receivedHrms62eWorktime(searchParams)
      this.receivedHrms62eCodleave(searchParams)
      this.getEntitlement()
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  computed: {
    inputName () {
      let inputName = this.currentCodempid + ' ' + this.descCodempid
      if (typeof this.detail.codinput !== 'undefined') {
        inputName = this.detail.codinput + ' ' + this.detail.desc_codinput
      }
      return inputName
    },
    validateStaappr () {
      return (this.detail.staappr !== 'A' && this.detail.staappr !== 'Y' && this.detail.staappr !== 'N')
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    getEntitlement () {
      let searchParams = {
        p_dtereq: this.detail.dtereq,
        p_seqno: this.detail.seqno,
        p_codleave: this.detail.codleave,
        p_dtestrt: this.detail.dtestrt,
        p_dteend: this.detail.dteend,
        p_timstrt: this.detail.timstrt.replace(':', ''),
        p_timend: this.detail.timend.replace(':', ''),
        p_flgleave: this.detail.flgleave,
        p_codempid_query: this.paramSearchDetail.codempid_query
      }
      this.receivedHrms62eEntitlement(searchParams)
    },
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    detailFlgleave () {
      if (this.enableFlagLeave.r1 === 'T') {
        this.detail.flgleave = 'A'
      } else if (this.enableFlagLeave.r2 === 'T') {
        this.detail.flgleave = 'M'
      } else if (this.enableFlagLeave.r3 === 'T') {
        this.detail.flgleave = 'E'
      } else if (this.enableFlagLeave.r4 === 'T') {
        this.detail.flgleave = 'H'
      }
    },
    triggerDetailFlgleaveChanged (flgleave) {
      this.detail.dtestrt = this.detail.dteleave
      this.detail.dteend = this.detail.dteleave
      if (flgleave === 'A') {
        this.disabledDtestrt = true
        this.disabledTimstrt = true
        this.disabledDteend = false
        this.disabledTimend = true
        this.detail.timstrt = '' // don't show  this.worktime.m_timstrt
        this.detail.timend = '' // don't show  this.worktime.e_timend
      } else if (flgleave === 'M') {
        this.disabledDtestrt = true
        this.disabledTimstrt = true
        this.disabledDteend = true
        this.disabledTimend = true
        this.detail.timstrt = this.worktime.m_timstrt
        this.detail.timend = this.worktime.m_timend
      } else if (flgleave === 'E') {
        this.disabledDtestrt = true
        this.disabledTimstrt = true
        this.disabledDteend = true
        this.disabledTimend = true
        this.detail.timstrt = this.worktime.e_timstrt
        this.detail.timend = this.worktime.e_timend
      } else if (flgleave === 'H') {
        this.disabledDtestrt = false
        this.disabledTimstrt = false
        this.disabledDteend = false
        this.disabledTimend = false
        this.detail.timstrt = this.worktime.m_timstrt
        this.detail.timend = this.worktime.e_timend
      }
      if (this.detail.timstrt !== '') {
        if (this.detail.timstrt < this.worktime.m_timstrt) {
          this.detail.dtestrt = moment(moment(this.detail.dteleave, 'DD/MM/YYYY').add(1, 'days')).format('DD/MM/YYYY')
        }
      }
      if (this.detail.timend !== '') {
        if (this.detail.timend < this.worktime.m_timstrt) {
          this.detail.dteend = moment(moment(this.detail.dteleave, 'DD/MM/YYYY').add(1, 'days')).format('DD/MM/YYYY')
        }
      }
      this.$nextTick(() => {
        this.errors.clear()
      })
    },
    validateCodempidQuery () {
      let _this = this
      if (_this.eventBtn === 'add') {
        _this.receivedHrms62eCreate(_this.paramSearchDetail)
      }
    },
    leaveCondition () {
      let popupParams = {
        codleave: this.detail.codleave
      }
      window.scrollTo(0, 0)
      this.receivedHrms62ePopup(popupParams)
    },
    saveParams () {
      return {
        p_codempid_query: this.paramSearchDetail.codempid_query,
        codempid: this.currentCodempid,
        staappr: this.detail.staappr,
        seqno: '' + this.currentNumseq,
        codleave: this.detail.codleave,
        flgleave: this.detail.flgleave,
        dtereq: this.currentDtereq,
        dteleave: this.detail.dteleave,
        dtestrt: this.detail.dtestrt,
        dteend: this.detail.dteend,
        timstrt: this.detail.timstrt.replace(':', ''),
        timend: this.detail.timend.replace(':', ''),
        deslereq: this.detail.deslereq,
        desc_codleave: this.detail.desc_codleave,
        filenam1: this.detail.filenam1
      }
    },
    callSave () {
      let _this = this
      this.detail.filenam1 = this.$refs.hrmsDropzone.inputFileName
      this.$validator.validateAll().then(result => {
        if (result) {
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel')
          },
          function (isConfirm) {
            if (isConfirm) {
              _this.postHrms62eSave({ saveParams: _this.saveParams(), searchParams: _this.searchIndex })
            }
          })
        }
      })
    },
    triggerToggle () {
      this.toggle('index')
      this.receivedHrms62eIndex(this.searchIndex)
    }
  },
  components: {
    popup
  }
}
</script>




// WEBPACK FOOTER //
// detail.vue?6e3e81f7